function _typeof(obj) {
    '@babel/helpers - typeof';
    if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
        _typeof = function _typeof(obj) {
            return typeof obj;
        };
    } else {
        _typeof = function _typeof(obj) {
            return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
        };
    }
    return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === 'object' || typeof call === 'function')) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
    }
    return self;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== 'function' && superClass !== null) {
        throw new TypeError('Super expression must either be null or a function');
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass)
        _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
import Component from '../component.js';
import Tech from './tech.js';
import * as Dom from '@emav-util/dom.js';
import toTitleCase from '@emav-util/to-title-case.js';
import mergeOptions from '@emav-util/merge-options.js';
var MediaLoader = function (_Component) {
    _inherits(MediaLoader, _Component);
    function MediaLoader(player, options, ready) {
        var _this;
        _classCallCheck(this, MediaLoader);
        var options_ = mergeOptions({ createEl: false }, options);
        _this = _possibleConstructorReturn(this, _getPrototypeOf(MediaLoader).call(this, player, options_, ready));
        if (!options.playerOptions.sources || options.playerOptions.sources.length === 0) {
            for (var i = 0, j = options.playerOptions.techOrder; i < j.length; i++) {
                var techName = toTitleCase(j[i]);
                var tech = Tech.getTech(techName);
                if (!techName) {
                    tech = Component.getComponent(techName);
                }
                if (tech && tech.isSupported()) {
                    console.log('MediaLoader:', techName, player, player.el_);
                    Dom.addClass(player.el_, 'emav-using-'.concat(j[i], '-tech'));
                    player.loadTech_(techName);
                    break;
                }
            }
        } else {
            player.src(options.playerOptions.sources);
        }
        return _this;
    }
    return MediaLoader;
}(Component);
export default MediaLoader;